import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/core/service/auth.service";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { IUser } from "src/app/core/model/User.model";

interface ROUTE {
  icon?: string;
  route?: string;
  title?: string;
}

@Component({
  selector: "app-customer-layout",
  templateUrl: "./customer-layout.component.html",
  styleUrls: ["./customer-layout.component.scss"],
})
export class CustomerLayoutComponent implements OnInit {
  appTitle = environment.appTitle;
  currentUser = {} as IUser;

  myWorkRoutes: ROUTE[] = [
    {
      icon: "dashboard",
      route: "/customer",
      title: "Dashboards",
    },
    {
      icon: "shop",
      route: "/customer/catalog",
      title: "Servizi",
    },
    {
      icon: "location_on",
      route: "/customer/office",
      title: "Sedi",
    },
  ];

  constructor(private authSevice: AuthService, private router: Router) {}

  ngOnInit() {
    this.authSevice.getUserProfile().subscribe((user) => {
      this.currentUser = user;
    });
  }

  goToCartPage() {
    this.router.navigate(["/customer/cart"]);
  }

  onSignOut() {
    this.authSevice.logout();
    this.router.navigate(["/login"]);
  }

  goToOrderPage() {
    this.router.navigate(["/customer/order"]);
  }

  goToProfilePage() {
    this.router.navigate(["/customer/profile"]);
  }

  goToDocumentPage() {
    this.router.navigate(["/customer/document"]);
  }

  goToPresencePage() {
    this.router.navigate(["customer/presence"]);
  }
}
